import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { NotificationService } from "../../common/services/notifications.service";
import { Subscription } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { trigger, transition, style, animate } from "@angular/animations";
import { WebsocketService } from '../../services/websocket/websocket.service';
import { UserDataService } from "../../services/user-data.service";
import { DateFormatPipe } from '../../common/pipes/date-format.pipe';
import { InboxService } from '../../services/inbox.service';
import { TabDataService } from '../../services/tab-data.service';
import { InquiryCache } from '../../common/cache/inquiry-cache';
import { RightNavigationService } from '../../services/panel/panel.service';
import { MessageService } from 'primeng/api';
import { OsNotificationService } from '../../services/os-notification/os-notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],

  animations: [
    trigger('items', [
      transition(':leave', [
        style({ transform: 'scale(1)', opacity: 1, height: '*' }),
        animate('1s cubic-bezier(.8, -0.6, 0.2, 1.5)')
      ])
    ])
  ]
})
export class NotificationComponent implements OnInit, OnDestroy {
  notificationArray: Array<any>;
  clickStatusArray: Array<boolean> = [false, false];
  native: any = 'native';
  private subscription: Subscription;
  public loginUserInfo: any;
  dateFormatPipe: DateFormatPipe;
  guserPrefDateFormat = '';
  protected requestFilter;
  public rowData: any;
  public dataExportToExcel: any;
  public strMailboxView = "";
  selectedMail: any;
  selectedInquiryId: any;
  selectedConvId: number;
  selectedInqId: number;
  componentName = "notification";
  subjectName = '';
  tabName: string = '';
  @Output() onFilter: EventEmitter<any> = new EventEmitter();
  @Input() showNotificationHtml;
  private assignedSubscription: Subscription;
  private newSubscription: Subscription;
  showAssignedInqNotification: boolean = false;
  showNewInqNotification: boolean = false;
  isUserToBeNotified: boolean = false;

  constructor(private notificationService: NotificationService,
              private wsService: WebsocketService,
              private userDataService: UserDataService,
              private inboxService: InboxService,
              private cdr: ChangeDetectorRef,
              private tabDataService: TabDataService,
              private inquiryCache: InquiryCache,
              private rightNavigationService: RightNavigationService,
              private httpClient: HttpClient,
              private messageService: MessageService,
              private osNotificationService: OsNotificationService
  ) {
    this.userDataService.LocalGetLoginUserInfo().subscribe(loginUserData => {
      this.loginUserInfo = loginUserData;
      let dateFormat = '';
      loginUserData.preferences.map(function (val) {
        if (val.key === "dateFormatterSelectId") {
          dateFormat = val.value;
        }
      });
      //this.guserPrefDateFormat = dateFormat;
      this.guserPrefDateFormat = "dd/MMM/yy";

      if (this.inquiryCache) {
        this.inquiryCache.init(this.componentName);
      }
      if (this.validateWSconnectionURL(this.loginUserInfo.wsHost)) {
        let CHAT_URL = this.loginUserInfo.wsHost + "/" + this.loginUserInfo.userId;
        // check if cvStreamingToken enebled
        if (this.loginUserInfo.cvWebsocketConfig.isCVWebSocketUpdateEnabled) {
          let wsUrl: string = this.loginUserInfo.cvWebsocketConfig.qmaWebSocketEndPoint;
          if (wsUrl.indexOf('streaming') > -1) {
            let tokenUrl: string = this.loginUserInfo.cvWebsocketConfig.cvStreamingTokenURL;
            const headers = new HttpHeaders()
                .set("X-Accept", "application/json");
            // on server using cvStreamingTokenURL
            this.httpClient.get(tokenUrl, { headers }).subscribe(data => {
              if (data && data['token']) {
                const token = data['token'];
                CHAT_URL = wsUrl + "/" + this.loginUserInfo.userId + '?&token=' + token;
                CHAT_URL += this.loginUserInfo.cvWebsocketConfig.isWebSocketRedesignEnable ? "&qma2" : "";
                // TODO :: Add websocket later
                this.connectToWs(CHAT_URL);
              }
            }, error => {
              // On local development environment cvStreamingTokenURL will not work.
              CHAT_URL += this.loginUserInfo.cvWebsocketConfig.isWebSocketRedesignEnable ? "?&qma2" : "";
              // TODO :: Add websocket later
              this.connectToWs(CHAT_URL);
            });

          }
        } else {
          // connect to websocket w/o token if 'isCVWebSocketUpdateEnabled' is false
          CHAT_URL += this.loginUserInfo.cvWebsocketConfig.isWebSocketRedesignEnable ? "?&qma2" : "";
          // TODO :: Add websocket later
          this.connectToWs(CHAT_URL);
        }
      }
    });
    this.dateFormatPipe = new DateFormatPipe();
    this.getAllNotification();
    //this.subjectName = "Pending Approval";
  }

  showNotificationFn(inq) {
    if (this.isUserToBeNotified) {
      const notificationMessage = this.osNotificationService.generateNotificationMessage(inq);

      this.osNotificationService.showNotification('QWYN - Delta Capita', {
          body: notificationMessage,
          icon: '/qwyn-icon.png',
      }, inq?._id);

      // Reset isUserToBeNotified
      this.isUserToBeNotified = false;
    }
  }

  // check if the user belongs to the group for seeing the new inq notification
  isUserInAssignedGroup(inq: any): boolean {
    if (inq?.allToCCGrps && this.loginUserInfo?.myGroups) {
      const assignedGroups = inq.allToCCGrps
        .split(';')
        .filter(groupName => groupName.trim() !== '');

      // if there are no assigned groups, exit
      if (assignedGroups.length === 0) {
        return false;
      }

      // create an array of the user's group names from the myGroups object
      const userGroupNames = this.loginUserInfo.myGroups.map(group => group.groupName);

      // return true if any of the assigned groups are found in the user's group list
      return assignedGroups.some(assignedGroup => userGroupNames.includes(assignedGroup));
    }
    // return false if data is missing
    return false;
  }

  // TODO :: Add websocket later till L:389
  connectToWs(CHAT_URL) {
    //CHAT_URL = "ws://localhost:8080/QMA/inquiryActions/XXXXX?&qma2"
    this.wsService.connect(CHAT_URL).subscribe(
        (response: MessageEvent): any => {
          // to update websocket records so other components in app can reuse
          let data: any;
          let notificationData: any;
          this.wsService.setwebSocketUpdate(response);
          if (this.loginUserInfo.cvWebsocketConfig.isCVWebSocketUpdateEnabled) {
            data = JSON.parse(response.data).wsInquiryList;
            notificationData = JSON.parse(response.data).wsInquiryList ? JSON.parse(response.data).wsInquiryList[0] : {};
          } else {
            data = JSON.parse(response.data);
            notificationData = data.wsInquiryList ? data.wsInquiryList : {};
          }
          if (this.inboxService.commonWsSubscribtion) {
            let inqIdArray = JSON.parse(response.data);
            for (let [key, value] of this.inboxService.wsQueue.entries()) {
              value.push(inqIdArray);
              this.inboxService.wsQueue.set(key, value);
            }
            this.inboxService.readWsQueue.next(true);
          }


          let action = '';
          let subject = '';
          let notificationSetting = [];
          let approvalFlag = false;
          let RejectFlag = false;
          let isUserId = false;
          let linkAction = ''
          if (data && (data.length > 0 || (data.wsInquiryList && data.wsInquiryList.length > 0))) {
            data = data.wsInquiryList && data.wsInquiryList.length > 0 ? data.wsInquiryList : data;
            // Get the selected assigned groups in dashboard setting
            let selGroups = JSON.parse(localStorage.getItem('groupNames')) || [];

            data.forEach(inq => {
              //pre-populate action and subject with websocket message's
              action = inq.action ? inq.action : action;
              subject = inq.subject ? inq.subject : subject;
              let workflows = [...inq.workflows];

              // Filter out the workflows according to dash board selected assigned groups.
              if (selGroups && selGroups.length > 0) {
                workflows = workflows.filter(wf => selGroups.includes(wf.assignedGroupName));
              }

              /******* Show OS level notification only if it's relevant to the logged-in user. | Do not move this inside the !isDuplicate check block *******/

              // checking if notify array exists first | will cause issues otherwise
              if (inq.notify && Array.isArray(inq.notify) && inq.notify.length > 0) {
                const loggedInUserId = this.loginUserInfo.userId.toLowerCase();
                this.isUserToBeNotified = inq.notify.some(userId =>
                    typeof userId === 'string' && userId.toLowerCase() === loggedInUserId
                );
              }

              // check if the user is directly assigned in the latest audit entry:
              const latestAudit = inq?.workflowAuditLimitedToRecentFive && inq.workflowAuditLimitedToRecentFive.length > 0 ? inq.workflowAuditLimitedToRecentFive[inq.workflowAuditLimitedToRecentFive.length - 1] : null;

              if (!this.isUserToBeNotified && latestAudit) { // only check if not already notified
                  if (latestAudit.action === "Assign Owner") {
                    // extract email from actionDetails, if present.
                    const emailRegex = /\(([^)]+)\)/; // Regex to find email inside ()
                    const match = latestAudit.actionDetails?.match(emailRegex);
                    const assignedEmail = match ? match[1] : null;

                      if (assignedEmail && this.loginUserInfo?.userId && this.showAssignedInqNotification) {
                          if (assignedEmail.toLowerCase() === this.loginUserInfo.userId.toLowerCase()) {
                              this.isUserToBeNotified = true;
                              this.showNotificationFn(inq);
                          }
                      }
                      // fallback
                      else if (inq?.workflows && inq.workflows.length > 0) {
                          const latestWorkflow = inq.workflows[inq.workflows.length - 1];
                          if (latestWorkflow.assignedUserId && this.loginUserInfo?.userId) {
                            if (latestWorkflow.assignedUserId.toLowerCase() === this.loginUserInfo.userId.toLowerCase() && this.showAssignedInqNotification) {
                                this.isUserToBeNotified = true;
                                this.showNotificationFn(inq);
                            }
                          }
                      }
                  } else if (latestAudit.action === "New Inquiry") {
                      if (this.isUserInAssignedGroup(inq) && this.showNewInqNotification) {
                          this.isUserToBeNotified = true;
                          this.showNotificationFn(inq);
                      }
                  } else {
                      // If not Assign Owner, check workflows normally
                      if (inq?.workflows && inq.workflows.length > 0) {
                          const latestWorkflow = inq.workflows[inq.workflows.length - 1];
                          if (latestWorkflow.assignedUserId && this.loginUserInfo?.userId && (latestWorkflow.action === 'Self Assign' || latestWorkflow.action === 'Assign Owner' || latestWorkflow.action === 'New Inquiry') && latestWorkflow.workflowStatus !== 'Approved - Re-age Inquiry') {
                            if (latestWorkflow.assignedUserId.toLowerCase() === this.loginUserInfo.userId.toLowerCase() && this.showAssignedInqNotification) {
                                this.isUserToBeNotified = true;
                                this.showNotificationFn(inq);
                            } else {
                              this.isUserToBeNotified = false;
                            }
                          }
                      }
                  }
              }

              // Show notification moved from here.
            /******* End of Show OS level notification only if it's relevant to the logged-in user. *******/

              workflows.reverse();
              workflows.forEach(item => {
                let updated = true;
                if (item.workflowStatus) {
                  let approvalTest = item.workflowStatus.split("-");
                  approvalFlag = approvalTest.indexOf("Approved ") !== -1;
                  let approvalReject = item.workflowStatus.split("-");
                  RejectFlag = approvalReject.indexOf("Rejected ") !== -1;
                }
                if (item.nominationRejectionReason) {
                  action = "approvals";
                  subject = "REJECTED";
                }
                if (subject !== "REJECTED") {
                  if (approvalFlag) {
                    action = "approvals";
                    subject = "APPROVED";
                  } else if (RejectFlag) {
                    action = "approvals";
                    subject = "REJECT";
                  } else if (item.workflowStatus == "Accepted - NOMINATE_OWNERSHIP" && item.direction === "IN" && !item.nominationRejectionReason && item.modBy == this.loginUserInfo.userId) {
                    action = "approvals";
                    subject = "ACCEPTED";
                  } else if (item.workflowStatus == "Pending - NOMINATE_OWNERSHIP" && item.direction === "NOMINATE_OWNERSHIP" && !item.nominationRejectionReason && item.modBy == this.loginUserInfo.userId) {
                    action = "approvals";
                    subject = "OWNERSHIP NOMINATION";
                  } else if (item.direction !== "IN" && item.direction !== "OUT" && item.direction !== "NOMINATE_OWNERSHIP") {
                    action = "approvals";
                    subject = "PENDING APPROVAL";
                  } else if (!this.isNull(item.generalEscalationReason) && item.isConvCountEscalation === "Y") {
                    action = "escalation";
                    subject = "ESCALATION";
                  } else if (!this.isNull(item.autoAssigned) && item.autoAssigned === "Y") {
                    action = "autoassign";
                    subject = "AutoAssigned";
                  } else if (!this.isNull(item.autoAssigned) && item.autoAssigned === "R") {
                    action = "autoassign";
                    subject = "AutoAssigned Revoked";
                  } else if (item.action === "FollowUp" || item.action === "Snooze" || item.action === "UnSnooze") {
                    action = (item.action == "UnSnooze") ? "snooze" : item.action.toLowerCase();
                    if (item.action === "Snooze") {
                      subject = "SNOOZE";
                    } else if (item.action === "UnSnooze") {
                      subject = "UNSNOOZE";
                    } else {
                      subject = "FOLLOW UP";
                    }
                  } else {
                    updated = false;
                  }
                } else {
                  updated = false;
                }
                if (!updated) {
                  // if action and subject have been updated by this workflow, but action is populated in workflow, take it for both fields.
                  action = item.action ? item.action : action;
                  subject = item.action ? item.action.toUpperCase() : subject;
                }
                this.subjectName = subject;
              });

              // C170665-455 | User should get the notification based on dashboard setting.
              // We are not considering empty workflow.
              if (workflows && workflows.length > 0) {
                if (inq.notify && inq.notify.length > 0) {
                  isUserId = inq.notify.indexOf(this.loginUserInfo.userId) !== -1;
                }
                for (const key in this.loginUserInfo.notificationSettings) {
                  if (this.loginUserInfo.notificationSettings[key]) {
                    notificationSetting.push(key.toLowerCase());
                  }
                }
                const isNotify = notificationSetting.indexOf(action) !== -1;
                inq.crtDate.$date = Object(this.dateFormatPipe.transform(inq.crtDate.$date, this.guserPrefDateFormat));
                const indx = this.inquiryCache.findIndex(this.componentName, inq._id);
                if ((isNotify) || (isUserId)) { // Notification should push for every change on inquiry
                  data[0].subject = subject;
                  // Check if notification with same _id and action already exists
                  const isDuplicate = this.notificationArray.some(notification =>
                      notification._id === inq._id && notification.action === inq.action
                  );

                  if (!isDuplicate) {
                    this.notificationArray.unshift(inq);
                    this.inquiryCache.add(this.componentName, inq, this.notificationArray.length - 1, this.notificationArray.length);
                    this.notificationService.setNotificationCount(this.notificationArray);
                    this.notificationService.filterCount(this.notificationArray);
                  }
                }
              }
            });

            // code for update on link/delink for BrazilFX from WS
            if (window.self !== window.top) { // condition added to only show notification in microUi
              if (notificationData && notificationData.linkEntities && notificationData.linkEntities.length > 0) { // check for linked Entities object
                notificationData.linkEntities.forEach(linkEntitiesData => {
                  if (linkEntitiesData.entityAction && linkEntitiesData.entityAction != '') {
                    if (linkEntitiesData.entityAction == 'link') {
                      linkAction = 'link deal'
                    } else if (linkEntitiesData.entityAction == 'link') {
                      linkAction = 'de-link deal'
                    }
                  }
                  if (linkEntitiesData.entityStatus == 'ACK') {
                    let displayMessage = 'The ' + linkAction + ' action on inquiry ' + linkEntitiesData.inquiryId + ' and ' + linkEntitiesData.entityType + ' ' + linkEntitiesData.entityId + ' successful.';
                    this.messageService.add({ severity: 'success', key: 'qmaToast', summary: '', detail: displayMessage });
                  } else if (linkEntitiesData.entityStatus == 'NACK') {
                    let displayMessage = 'The ' + linkAction + ' action on inquiry ' + linkEntitiesData.inquiryId + ' and ' + linkEntitiesData.entityType + ' ' + linkEntitiesData.entityId + ' failed.';
                    this.messageService.add({ severity: 'error', key: 'qmaToast', summary: '', detail: displayMessage });
                  }
                });
              }
            }
          }
        }, error => {
          // Web socket connection failure
          console.error("websocketupdate: connecting to ws url in notification.connectToWs.error()", error);
        }
    );
  }
  getAllNotification() {
    let approvalFlag = false;
    let tabName = '';
    //this.subjectName = "Pending Approval";
    this.notificationService.getNotifyUserInquiry().subscribe(notifyData => {
      notifyData.userNotificationsList?.forEach(item => {
        let ind = this.notificationArray.findIndex((ele: any) => ele._id == item.inquiryId);
        // Check for duplicate based on both _id and action
        let isDuplicate = this.notificationArray.some((ele: any) =>
            ele._id === item.inquiryId && ele.action === item.action
        );
        item.crtDate = Object(this.dateFormatPipe.transform(item.crtDate, this.guserPrefDateFormat));
        let date = {
          $date: item.crtDate
        }
        if (!isDuplicate) {
          item.workflows?.forEach(item => {
            if (item.workflowStatus) {
              let approvalTest = item.workflowStatus.split("-");
              approvalFlag = approvalTest.indexOf("Approved ") !== -1;
            }
            if (approvalFlag) {
              tabName = "Inbox";
            } else if (item.direction === "NOMINATE_OWNERSHIP") {
              tabName = "Pending Approval";
            } else if (item.direction !== "IN" && item.direction !== "OUT") {
              tabName = "Pending Approval";
            } else if (!this.isNull(item.generalEscalationReason) && item.isConvCountEscalation === "Y") {
              tabName = "Potential Escalations";
            } else if (item.action === "FollowUp" || item.action === "Snooze" || item.action === "UnSnooze") {
              if (item.action.toLowerCase() === "snooze") {
                tabName = "Snoozed";
              } else if (item.action.toLowerCase() === "unsnooze") {
                tabName = "Snoozed";
              } else {
                tabName = "Inbox";
              }
            }
          });

          let inquiry = {
            subject: tabName,
            action: item.action,
            _id: item.inquiryId,
            crtDate: date,
            type: item.type,
            userId: item.userId,
            id: item.id
          }
          this.notificationArray.unshift(inquiry);
          this.inquiryCache.add(this.componentName, inquiry, this.notificationArray.length - 1, this.notificationArray.length);
          this.notificationService.setNotificationCount(this.notificationArray);
          this.notificationService.filterCount(this.notificationArray);
        }
      });
    });
  }
  // Null value check function
  isNull(input) {
    if (input === "" || input === undefined || input == null) {
      return true;
    }
    return false;
  }
  onOptionClick(clickedItemIndex: number) {
    for (let i = 0; i < this.clickStatusArray.length; i++) {
      const val = this.clickStatusArray[i];
      this.clickStatusArray[i] = (clickedItemIndex === i) ? !val : false;
    }
  }
  viewNotification(item: any) {
    this.openInquiryView(item);
    this.notificationService.filter(item);
    this.notificationArray.forEach(function (val: any, index) {
      if (val._id === item._id) {
        this.splice(index, 1);
      }
    }, this.notificationArray);
    this.notificationService.filterCount(this.notificationArray);

  }

  /**
   * get tab name based on notification item
   */
  getTabName(item: any) {
    let approvalFlag = false;
    let rejectFlag = false;
    let tabName = '';
    item.workflows.forEach(item => {
      if (item.workflowStatus) {
        let approvalTest = item.workflowStatus.split("-");
        approvalFlag = approvalTest.indexOf("Approved ") !== -1 || approvalTest.indexOf("Accepted ") !== -1;
        //Notification open in related tab issue
        let approvalRejectTest = item.workflowStatus.split("-");
        rejectFlag = approvalRejectTest.indexOf("Rejected ") !== -1;
      } else {
        if (item.nominationRejectionReason) {
          tabName = "Inbox";
          this.tabName = "Inbox";
        }
      }
      if (this.tabName == "") {
        if (approvalFlag || rejectFlag) {
          tabName = "Inbox";
        } else if (item.direction === "NOMINATE_OWNERSHIP") {
          tabName = "Pending Approval";
        } else if (item.direction !== "IN" && item.direction !== "OUT") {
          tabName = "Pending Approval";
        } else if (!this.isNull(item.generalEscalationReason) && item.isConvCountEscalation === "Y") {
          tabName = "Potential Escalations";
        } else if (item.action === "FollowUp" || item.action === "Snooze" || item.action === "UnSnooze") {
          if (item.action.toLowerCase() === "snooze") {
            tabName = "Snoozed";
          } else if (item.action === "UnSnooze") {
            tabName = "Inbox";
          } else {
            tabName = "Inbox";
          }
        }
      }
    });
    return tabName;
  }

  /**
   *open inquiry with dedicated "INQUIRY:" tab
   */
  openInquiryView(item: any) {
    let assignedGroupIds = [];
    if (item.workflows) {
      item.workflows.forEach(wf => {
        let assignedGroupId = wf.assignedGroupId;
        if (this.userDataService.userGroupIdList.indexOf(assignedGroupId) > -1) {
          assignedGroupIds.push(assignedGroupId);
        }
      });
    }
    const assignedGroup = item.openGroups;
    let workflow = {
      queryCount: item.queryCount,
      requestType: item.requestTypeStr || null,
      inquirySource: item.inquirySource,
      processingRegion: item.processingRegion,
      rootCause: item.rootCause,
      tag: item.tag
    };
    let curInq = item;
    let hasNominatedOwnership = item.workflows[0].hasNominatedOwnership !== undefined ? item.workflows[0].hasNominatedOwnership : false;
    let inquiryData = {
      id: curInq._id,
      selectInqAssignedGroupId: assignedGroupIds,
      isAllConvContent: false, // do not load all content upon first load of conv view
      hasNominatedOwnership: hasNominatedOwnership
    };
    // Send request to get the all the inquiry conversation for the selected inquiry Id.
    this.inboxService.getInquiryIdExtSelected(inquiryData, curInq).subscribe(inquiryDetail => {
      // Set the conversation count
      let converationCount = inquiryDetail.conversationList.length;
      // re-trigger tab with the current inquiry
      this.tabDataService.setInquiryData({
        selectedMail: inquiryDetail,
        assignedGroup: assignedGroup,
        selectedConvId: null,
        selectedInqId: inquiryDetail.inquiry ? inquiryDetail.inquiry.id : null,
        inquiryWorkflow: workflow,
        inquirySubject: inquiryDetail.inquiry ? inquiryDetail.inquiry.subject : '',
        inquiryReportedConvCount: converationCount,
        mailContainerHeight: this.inboxService.currentViewHeight,
        inqData: inquiryData,
        inboxViewMode: 'tab',
        inboxViewName: this.getTabName(item)
      });
      this.tabDataService.sendTabData("INQUIRY:" + item._id, 0);
    });
  }

  validateWSconnectionURL(wsURL: string) {

    //ToDo: To revert to wss for more secured transactions and from the endswith QMA is removed. No url with QMA is created
    return (wsURL.startsWith('wss://') || wsURL.startsWith('ws://')) && wsURL.endsWith('/inquiryActions');
  }

  dismissNotification(item: any, event: any) {
    this.notificationService.dismissNotification(item);
    this.notificationService.filterCount(this.notificationArray);
    this.notificationService.updateNotifyUserInquiry({ "_id": item.id, "userId": item.userId }).subscribe(inquiryDetail => {
    });
    //this.notificationService.updateNotifyUserInquiry({"_id":item.id,"userId":item.userId})
  }

  dismissAll() {
    this.notificationService.dismissAllNotifications();
    this.notificationService.filterCount(this.notificationArray);

  }

  isYesterday(date: string): boolean {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const checkDate = new Date(date);

    return yesterday.getDate() === checkDate.getDate() &&
        yesterday.getMonth() === checkDate.getMonth() &&
        yesterday.getFullYear() === checkDate.getFullYear();
  }

  ngOnInit() {
    this.subscription = this.notificationService.notificationData.subscribe(notifications => {
      this.notificationArray = notifications;
      this.inquiryCache.addAll(this.componentName, this.notificationArray);
    });

    this.assignedSubscription = this.osNotificationService.enableBrowserNotificationsAssigned$.subscribe(isEnabled => {
      this.showAssignedInqNotification = isEnabled;
    });
    this.newSubscription = this.osNotificationService.enableBrowserNotificationsNew$.subscribe(isEnabled => {
      this.showNewInqNotification = isEnabled;
    });
    this.osNotificationService.loadFromLocalData();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.assignedSubscription) {
      this.assignedSubscription.unsubscribe();
    }
    if (this.newSubscription) {
      this.newSubscription.unsubscribe();
    }
  }

  /**
   * Method to close Panel
   */
  closePanel() {
    this.rightNavigationService.close();
  }

}
